(function () {
var $2d081a1fa49e40a2$exports = {};
/* scroll */ const $2d081a1fa49e40a2$var$navEl = document.querySelector("nav");
const $2d081a1fa49e40a2$var$anchors = document.querySelectorAll("nav a:not([target=_blank])");
const $2d081a1fa49e40a2$var$anchoredElements = [
    ...$2d081a1fa49e40a2$var$anchors
].map((anchor)=>{
    const href = anchor.getAttribute("href");
    return document.querySelector(`${href}`);
});
const $2d081a1fa49e40a2$var$elementToNavAnchor = new Map($2d081a1fa49e40a2$var$anchoredElements.map((element, index)=>[
        element,
        $2d081a1fa49e40a2$var$anchors[index]
    ]));
let $2d081a1fa49e40a2$var$oldScroll = window.scrollY;
let $2d081a1fa49e40a2$var$scrollDirectionDown = true;
function $2d081a1fa49e40a2$var$checkVisible(elm, threshold, mode) {
    threshold = threshold || 0;
    mode = mode || "visible";
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    const above = rect.bottom - threshold < 0;
    const below = rect.top - viewHeight + threshold >= 0;
    return mode === "above" ? above : mode === "below" ? below : !above && !below;
}
function $2d081a1fa49e40a2$var$updateNavSelection(scrollingDown) {
    const direction = scrollingDown ? -1 : 1;
    const from = scrollingDown ? $2d081a1fa49e40a2$var$anchors.length : -1;
    const to = scrollingDown ? 0 : $2d081a1fa49e40a2$var$anchors.length - 1;
    let current = from;
    let activeSet = false;
    do {
        current += direction;
        const anchoredElement = $2d081a1fa49e40a2$var$anchoredElements[current];
        if (!anchoredElement) continue;
        const visible = $2d081a1fa49e40a2$var$checkVisible(anchoredElement, 150);
        $2d081a1fa49e40a2$var$elementToNavAnchor.get(anchoredElement).classList.toggle("active", !activeSet && visible);
        activeSet = activeSet || visible;
    }while (current != to);
}
window.addEventListener("scroll", ()=>{
    $2d081a1fa49e40a2$var$scrollDirectionDown = $2d081a1fa49e40a2$var$oldScroll < window.scrollY;
    $2d081a1fa49e40a2$var$oldScroll = window.scrollY;
    $2d081a1fa49e40a2$var$updateNavSelection($2d081a1fa49e40a2$var$scrollDirectionDown);
});
/* navigation */ const $2d081a1fa49e40a2$var$navButton = document.querySelector(".menu-toggle");
$2d081a1fa49e40a2$var$navButton.addEventListener("click", (event)=>{
    $2d081a1fa49e40a2$var$navButton.classList.toggle("open");
    $2d081a1fa49e40a2$var$navEl.classList.toggle("open");
});
$2d081a1fa49e40a2$var$navEl?.addEventListener("click", (event)=>{
    if (!window.matchMedia("(max-width: 768px)").matches) return;
    if (event.target instanceof HTMLAnchorElement) {
        $2d081a1fa49e40a2$var$navButton.classList.remove("open");
        $2d081a1fa49e40a2$var$navEl.classList.remove("open");
    }
});
/* accordion */ const $2d081a1fa49e40a2$var$getActualHeight = (element)=>{
    const style = window.getComputedStyle(element);
    const margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    return Math.ceil(element.offsetHeight + margin);
};
document.querySelectorAll("[data-role=expandable]").forEach((expandable)=>{
    const title = expandable.querySelector("[data-role=title]");
    const content = expandable.querySelector("[data-role=content]");
    const contentWrapper = document.createElement("div");
    contentWrapper.style.overflow = "hidden";
    contentWrapper.style.transition = "all 0.3s ease-in-out";
    contentWrapper.style.height = "0";
    title.after(contentWrapper);
    contentWrapper.append(content);
    title?.addEventListener("click", (event)=>{
        const toOpen = !expandable.classList.contains("expanded");
        if (toOpen) {
            const contentHeight = content.offsetHeight;
            contentWrapper.style.height = contentHeight + "px";
        } else contentWrapper.style.height = "0";
        expandable.classList.toggle("expanded");
    });
});
/* read more */ document.querySelectorAll("[data-role=read_more]").forEach((expandable)=>{
    const buttonContainer = expandable.querySelector("[data-role=expand]");
    const parent = expandable.closest(".article-section");
    buttonContainer?.addEventListener("click", (event)=>{
        const currentState = expandable.dataset.expandState;
        if (currentState === "open") parent.scrollIntoView(true);
        event.stopPropagation();
        event.preventDefault();
        expandable.dataset.expandState = currentState === "closed" ? "open" : "closed";
    });
});
/* dialog */ const $2d081a1fa49e40a2$var$dialog = document.querySelector("dialog.reference_dialog");
document.querySelector("[data-role=open_dialog]").addEventListener("click", (event)=>{
    $2d081a1fa49e40a2$var$dialog.showModal();
});
document.querySelector("dialog button").addEventListener("click", (event)=>{
    $2d081a1fa49e40a2$var$dialog.close();
});

})();
//# sourceMappingURL=index.5e0ab5cd.js.map
